import { all } from "redux-saga/effects";

import AlertSaga from "./Alerts/saga";
import AuthSagas from "./Auth/saga";
import itemsSaga from "./Items/saga";
import rolesSaga from "./Roles/saga";
import userSagas from "./Users/saga";
import CareHomeGroupsSaga from "./CareHomeGroups/saga";
import HomesSaga from "./Homes/saga";
import EnquiriesSaga from "./Enquiries/saga";
import NewsSaga from "./News/saga";
import FaqsSaga from "./Faqs/saga";
import HomeGroupsAdminSaga from "./HomeGroupsAdmin/saga";
import PagesSaga from "./Pages/saga";
import SlickCareProfilesSaga from "./SlickCareProfiles/saga";
import HomeGroupsStaffSaga from "./HomeGroupsStaff/saga";
import BlogsSaga from "./Blogs/saga";
import ResidenceSaga from "./Residence/saga";
import TOCSaga from "./TypesOfCare/saga";
import LocationBlogsSaga from "./LocationBlogs/saga";
import WebsiteSaga from "./Website/saga";
import RoomSaga from "./Rooms/saga";
import SettingsSaga from "./EmailSettings/saga";
import ReviewsSaga from "./Reviews/saga";
import ContactSaga from "./Contacts/saga";
import ReviewSettingsSaga from "./ReviewSetting/saga";
import PackageSaga from "./Package/saga";
import HistorySaga from "./History/saga";
import PrintSaga from "./Print/saga";
import NetworkSaga from "./Networking/saga";
import TaskSaga from "./Task/saga";
import SurveySaga from "./Survey/saga";
import BundlesSaga from "./Bundles/saga";
import WebsiteEnquiriesSaga from "./WebsiteEnquiries/saga";

// Roster
import RosterRoleSaga from "./EmployeeRole/saga";
import EmployeeSaga from "./Employee/saga";
import LeaveSaga from "./EmployeeLeave/saga";
import ShiftSaga from "./EmployeeShifts/saga";
import RotaSaga from "./EmployeeRota/saga";
import BudgetSaga from "./Budget/saga";
import SheetSaga from "./Timesheet/saga";
import RosterSaga from "./Roster/saga";
import HubBlogSaga from "./HubBlog/saga";
import DiscrepancySaga from "./Discrepancy/saga";
import AvailabilitySaga from "./Availability/saga";
import TerminalSaga from "./Terminals/saga";
import NotificationSaga from "./Notification/saga";
import TeamSaga from "./Teams/saga";
import FeedSaga from "./Feed/saga";
import FeedActionSaga from "./FeedAction/saga";
import CommentSaga from "./FeedComments/saga";

export default function* rootSaga() {
  yield all([
    userSagas(),
    AuthSagas(),
    rolesSaga(),
    itemsSaga(),
    AlertSaga(),
    CareHomeGroupsSaga(),
    HomesSaga(),
    EnquiriesSaga(),
    NewsSaga(),
    FaqsSaga(),
    HomeGroupsAdminSaga(),
    PagesSaga(),
    SlickCareProfilesSaga(),
    HomeGroupsStaffSaga(),
    BlogsSaga(),
    ResidenceSaga(),
    TOCSaga(),
    LocationBlogsSaga(),
    WebsiteSaga(),
    RoomSaga(),
    SettingsSaga(),
    ReviewsSaga(),
    ContactSaga(),
    ReviewSettingsSaga(),
    PackageSaga(),
    HistorySaga(),
    PrintSaga(),
    NetworkSaga(),
    TaskSaga(),
    SurveySaga(),
    BundlesSaga(),
    //
    RosterRoleSaga(),
    EmployeeSaga(),
    LeaveSaga(),
    ShiftSaga(),
    RotaSaga(),
    BudgetSaga(),
    SheetSaga(),
    RosterSaga(),
    WebsiteEnquiriesSaga(),
    HubBlogSaga(),
    DiscrepancySaga(),
    AvailabilitySaga(),
    TerminalSaga(),
    NotificationSaga(),
    TeamSaga(),
    FeedSaga(),
    FeedActionSaga(),
    CommentSaga(),
  ]);
}
